export const DISPOSAL_FEE_ACCOUNTS_TAB_ID = 'ACCOUNTS'
export const DISPOSAL_FEE_SERVICES_TAB_ID = 'SERVICES'
